import { Injectable } from "@angular/core";
import * as Highcharts from "highcharts";

@Injectable({
    providedIn: "root"
})
export class BarService {
    constructor() {}

    getOptions(
        yAxis,
        series,
        categories,
        inverted,
        height,
        stacking,
        colors = []
    ) {
        const options: Highcharts.Options = {
            chart: {
                inverted: inverted,
                type: "column",
                height: height
            },
            title: {
                text: ""
            },
            xAxis: {
                categories: categories,
                title: {
                    text: null
                },
                max: series[0]["data"].length > 50 ? 50 : null
            },
            yAxis: yAxis,
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true
                    }
                },
                series: {
                    label: {
                        enabled: false
                    },
                    stacking: stacking
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            series: series
        };

        if (colors.length > 0) {
            options.colors = colors;
        }

        return options;
    }
}
